'use client'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { usePathname } from 'next/navigation'

import CustomLink from '@/shared/components/customLink'
import HeaderDropdown from '../headerDropDown'
import { getSlugUrl } from '@/shared/utils'
import { useQuery } from '@apollo/client'
import { CURRENT_SERIES_LIST } from '@/graphql/globalwidget/rankings.query'

type headerMenuPropType = {
  toggleSideMenu?: () => void
  headerData: any[]
}

function HeaderMenu({ headerData }: headerMenuPropType) {
  // (await queryGraphql(CURRENT_SERIES_LIST))?.data?.getCurrentPopularSeries?.aResults
  const [dropDown, setDropDown] = useState(headerData)
  useQuery(CURRENT_SERIES_LIST, {
    onCompleted: data => {
      setDropDown(
        dropDown.map(header => {
          if (header.oChildren) {
            return { ...header, oChildren: data?.getCurrentPopularSeries?.aResults }
          }
          return header
        })
      )
    }
  })
  const asPath = usePathname()
  const isActive = (slug: string) => {
    return asPath === '/' + slug || (slug && asPath.startsWith(slug))
  }

  return (
    <div className={`flex text-nowrap items-center h-full text-base font-medium`}>
      <ul className="flex h-full items-center">
        {dropDown?.map((m: any) => {
          if (m?.oChildren?.length) {
            return (
              <li
                key={m?.sTitle}
                className={`cursor-pointer h-full group border-transparent border-b-2 ${
                  isActive(getSlugUrl(m?.sSlug))
                    ? 'border-separator bg-headersActive dark:border-b-primary-500 border-b-underLine'
                    : ''
                } transition-all hover:dark:border-b-primary-500 hover:border-b-underLine`}
              >
                <CustomLink
                  target={m?.eUrlTarget}
                  href={
                    m?.eMenuType === 'outside'
                      ? m?.sUrl || '/' + getSlugUrl(m?.sSlug)
                      : '/' + getSlugUrl(m?.sSlug)
                  }
                  className={`px-5 whitespace-nowrap flex dark:!text-white !text-[#646A6E] h-full items-center hover:text-t-origin uppercase`}
                >
                  {m?.sTitle}
                </CustomLink>

                <HeaderDropdown subMenu={m?.oChildren} />
              </li>
            )
          } else {
            return (
              <li
                key={m?.sTitle}
                className={`h-full border-b-2 border-transparent transition-all  ${
                  isActive(getSlugUrl(m?.sSlug))
                    ? 'dark:border-b-primary-500 border-b-underLine bg-headersActive'
                    : ' dark:!text-white !text-[#646A6E] hover:dark:border-b-primary-500 hover:border-b-underLine'
                }`}
              >
                <CustomLink
                  target={m?.eUrlTarget}
                  href={
                    m?.eMenuType === 'outside'
                      ? m?.sUrl || '/' + getSlugUrl(m?.sSlug)
                      : '/' + getSlugUrl(m?.sSlug)
                  }
                  className={`px-5 whitespace-nowrap flex ${isActive(getSlugUrl(m?.sSlug)) ? 'text-t-black' : 'dark:!text-white !text-[#646A6E]'}  h-full items-center hover:text-t-origin uppercase `}
                >
                  {m?.sTitle}
                </CustomLink>
              </li>
            )
          }
        })}
      </ul>
    </div>
  )
}

HeaderMenu.propTypes = {
  toggleSideMenu: PropTypes.func
}

export default HeaderMenu
